import React from 'react';
import { bool, shape, string } from 'prop-types';

const CheckSquareRounded = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="2" fill="currentColor" />
    <path d="m10.58 16.09-3.3-3.3 1.42-1.41 1.88 1.88 5.3-5.3 1.41 1.41z" fill="#fff" />
  </svg>
);

CheckSquareRounded.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CheckSquareRounded;
